/**
 * The section an address points at: "/#contact" lands on the contact section.
 * A one-page site links to its sections this way (nav, buttons, shared links),
 * so opening the page has to go there rather than to the top.
 * @param {string} hash The address's hash, "#contact" or "".
 * @param {(id: string) => T | null} findById Looks an element up by id (document.getElementById).
 * @returns {T | null} The section, or null for no hash or one the page does not have.
 */
const hashTarget = <T>(hash: string, findById: (id: string) => T | null): T | null => {
  const raw = hash.replace(/^#/u, "");
  if (raw === "") {
    return null;
  }
  try {
    return findById(decodeURIComponent(raw));
  } catch {
    // A malformed escape ("#%E0") names no section.
    return null;
  }
};

export { hashTarget };
